<td class="activity-icons-col actions">
    <cb-lot-build-programme-activity-icons [lotDto]="lotDto" [buildProgrammeActivity]="activity">
    </cb-lot-build-programme-activity-icons>
</td>

<td>{{ activity?.activity?.code | cbDasher }}</td>
<td>{{ activity?.activity?.name | cbDasher }}</td>
@if (displayUnitNumber) {
    <td>{{ activity?.lotNumber | cbDasher }}</td>
}
<td>{{ activity?.supplierName | cbDasher }}</td>
<td>
  <span
    [matTooltip]="(activity?.actualStartDate ?? activity?.estimatedStartDate) | date:'fullDate'">
    {{ (activity?.actualStartDate ?? activity?.estimatedStartDate) | date }}
  </span>
</td>
<td>
  <span
    [matTooltip]="(activity?.actualEndDate ?? activity?.estimatedEndDate) | date:'fullDate'">
    {{ (activity?.actualEndDate ?? activity?.estimatedEndDate) | date }}
  </span>
</td>
<td
    [ngClass]="{
        'table-accent':
            !activity?.activityDurationDays &&
            activity?.statusId !== BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Abandoned
    }"
>
    {{ activity?.activityDurationDays | cbDasher }}
</td>
<td>
    {{ activity?.purchaseOrderSummaryDto?.orderSubtotal | currency }}
</td>
<td class="actions">
    @if (activity.statusId !== BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Abandoned) {
        <cb-lot-build-programme-activity-menu
            [lot]="lotDto"
            [buildProgrammeActivity]="activity"
            [downloadOnly]="downloadOnly"
        >
        </cb-lot-build-programme-activity-menu>
    }
</td>
